import { createContext, useContext } from 'react'
import { Frame } from '@/types/codegen-federation'
import { ReactFCC } from '@/types/react'

const FrameContext = createContext<Frame | undefined>(undefined)

const FrameProvider: ReactFCC<{ frame: Frame | undefined }> = ({ frame, children }) => {
  return <FrameContext.Provider value={frame}>{children}</FrameContext.Provider>
}

const useFrame = () => {
  const context = useContext(FrameContext)
  return context
}

export { FrameProvider, useFrame }
